document.addEventListener('DOMContentLoaded', () => {

  // ==========================================================================
  // 逻辑一：点击按钮，展示相邻的视频组件
  // ==========================================================================
  const videoButtons = document.querySelectorAll('.product-gallery-video-btn');

  videoButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const videoShow = btn.parentElement.querySelector('.product-gallery-video-show') 
                     || btn.nextElementSibling;
      
      if (videoShow) {
        videoShow.style.display = 'flex';
      }
    });
  });

  // ==========================================================================
  // 逻辑二：点击缩略图区域，前置判断是否存在视频组件
  // ==========================================================================
  const scrollShadows = document.querySelectorAll('scroll-shadow');

  scrollShadows.forEach(shadow => {
    shadow.addEventListener('click', () => {
      // 1. 向上寻找最近的共同父级容器
      const stickyParent = shadow.closest('.product-gallery-sticky');
      if (!stickyParent) return; // 如果连父级都没找到，直接返回

      // 2. 在此父级下探测有没有这个视频组件
      const videoShow = stickyParent.querySelector('.product-gallery-video-show');
      
      // 3. 如果没有检测到该元素，直接 return 返回，不执行任何后续操作
      if (!videoShow) {
        console.log('未检测到视频展示组件，流程安全返回。');
        return; 
      }

      // 4. 有的话，继续执行原定逻辑：将其隐藏
      videoShow.style.display = 'none';
      
      // 5. 获取里面的原生 video 标签并执行暂停
      const video = videoShow.querySelector('video');
      if (video) {
        video.pause();
      }
    });
  });

});